module.exports = __webpack_public_path__ + "IntegraWatch-logo.70f27849.svg";